import validate from "/opt/buildhome/repo/node_modules/.pnpm/nuxt@3.15.2_@parcel+watcher@2.5.0_@types+node@22.3.0_db0@0.2.1_eslint@8.51.0_ioredis@5.4.2_ma_pyf3aitgv3lgs4ljrhbtmphm6q/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/opt/buildhome/repo/middleware/auth.global.ts";
import manifest_45route_45rule from "/opt/buildhome/repo/node_modules/.pnpm/nuxt@3.15.2_@parcel+watcher@2.5.0_@types+node@22.3.0_db0@0.2.1_eslint@8.51.0_ioredis@5.4.2_ma_pyf3aitgv3lgs4ljrhbtmphm6q/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}